export default __webpack_public_path__ + "static/media/icon-bookmark.f980949d.svg";